import React, { useContext } from 'react';
import { withStyles } from "@material-ui/core/styles";
import CloseButtonDialog from './CloseButtonDialog';
import Grid from '@material-ui/core/Grid';
import DialogActions from '@material-ui/core/DialogActions';
import Button from '@material-ui/core/Button';
import axios from 'axios';
import _ from 'underscore';
import Libro from 'App/Libros/index';
import { LayoutContext } from 'App/Layout/store';


const styles = theme => ({
    root: {
        flexGrow: 1,
    },
    paper: {
        padding: theme.spacing.unit * 2,
        textAlign: 'center',
        color: theme.palette.text.secondary,
    },
});

const defaultToolbarSelectStyles = {
    iconButton: {
        marginRight: "24px"
    }
};


function ModalDTEs(props) {
    const { classes } = props;

    const layoutContext = useContext(LayoutContext);

    var content =
        layoutContext.state.dtesLibro.length?
        <Grid container>
            <Libro accionAgregar={(e,r)=>{
                var conf = window.confirm("¿Está seguro de querer agregar los Documentos seleccionados a este Libro?");
                if (conf) {
                    e.preventDefault();
                    axios.post(`/api/libro/${r[0]}/agregar`,layoutContext.state.dtesLibro)
                    .then(o=>alert("DTEs agregados exitosamente"))
                    .catch(e => /*alert(e.response.data.Mensaje)*/{})
                    .finally(()=>layoutContext.dispatch({type:"agregaDteLibro",dtesLibro:[]}))
                }
            }} agregar/>
        </Grid>
        :null;

    const footer = (
        <DialogActions>
            <Button onClick={() => layoutContext.dispatch({type:"agregaDteLibro",dtesLibro:[]})} color="secondary" autoFocus>
                Cerrar
            </Button>
        </DialogActions>
    );

    return (
        <div>
            <CloseButtonDialog open={layoutContext.state.dtesLibro.length} onClose={() => layoutContext.dispatch({type:"agregaDteLibro",dtesLibro:[]})} closeButton title="Libros disponibles" content={content} footer={footer} size="md" />
        </div>
    );
}

export default withStyles(styles)(React.memo(ModalDTEs));